import { render, staticRenderFns } from "./AccountsList.vue?vue&type=template&id=253677e2&"
import script from "./AccountsList.vue?vue&type=script&lang=js&"
export * from "./AccountsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports